export default __webpack_public_path__ + "static/media/clear_icon.5b99417a.svg";